import * as dom from './wpstg-dom-utils.js';

/**
 * Database tables selection
 */
export default class WpstgTableSelection {
  constructor(
      databaseTableSectionSelector = '#wpstg-scanning-db',
      workflowSelector = '#wpstg-workflow',
      networkCloneSelector = '#wpstg_network_clone',
      wpstgObject = wpstg,
  ) {
    this.databaseTableSection = dom.qs(databaseTableSectionSelector);
    this.workflow = dom.qs(workflowSelector);
    this.networkCloneSelector = networkCloneSelector;
    this.networkCloneCheckbox = dom.qs(networkCloneSelector);
    this.wpstgObject = wpstgObject;
    this.isAllTablesChecked = true;
    this.isMultisite = this.wpstgObject.isMultisite === '1';
    this.isNetworkClone = false;

    this.init();
  }

  setNetworkClone(isNetworkClone) {
    this.isNetworkClone = isNetworkClone;
  }

  addEvents() {
    if (this.workflow === null) {
      console.log('Error: database table section is null. Cannot register events');
      return;
    }

    dom.addEvent(this.workflow, 'change', this.networkCloneSelector, () => {
      this.selectDefaultTables();
    });

    dom.addEvent(this.workflow, 'click', '.wpstg-button-select', (target, event) => {
      event.preventDefault();
      this.selectDefaultTables();
    });

    dom.addEvent(this.workflow, 'click', '.wpstg-button-unselect', (target, event) => {
      event.preventDefault();
      this.toggleTableSelection();
    });
  }

  init() {
    this.addEvents();
  }

  getRegexPattern() {
    let pattern = '^' + this.wpstgObject.tblprefix;
    let isNetwork = false;
    if (this.networkCloneCheckbox !== undefined && this.networkCloneCheckbox !== null) {
      isNetwork = this.networkCloneCheckbox.checked;
    }

    // Force network clone true if set explicitly
    if (this.isNetworkClone) {
      isNetwork = true;
    }

    if (this.isMultisite && !isNetwork) {
      pattern += '([^0-9])_*';
    }

    return pattern;
  }

  selectDefaultTables() {
    const options = this.databaseTableSection.querySelectorAll('#wpstg_select_tables_cloning .wpstg-db-table');
    const regexPattern = this.getRegexPattern();
    options.forEach((option) => {
      const name = option.getAttribute('name', '');
      if (name.match(regexPattern)) {
        option.selected = true;
      } else {
        option.selected = false;
      }
    });
  }

  toggleTableSelection() {
    if (false === this.isAllTablesChecked) {
      this.databaseTableSection.querySelectorAll('#wpstg_select_tables_cloning .wpstg-db-table').forEach((option) => {
        option.selected = true;
      });
      this.databaseTableSection.querySelector('.wpstg-button-unselect').innerHTML = 'Unselect All';
      // cache.get('.wpstg-db-table-checkboxes').prop('checked', true);
      this.isAllTablesChecked = true;
    } else {
      this.databaseTableSection.querySelectorAll('#wpstg_select_tables_cloning .wpstg-db-table').forEach((option) => {
        option.selected = false;
      });
      this.databaseTableSection.querySelector('.wpstg-button-unselect').innerHTML = 'Select All';
      // cache.get('.wpstg-db-table-checkboxes').prop('checked', false);
      this.isAllTablesChecked = false;
    }
  }

  getSelectedTablesWithoutPrefix() {
    const selectedTablesWithoutPrefix = [];
    const options = this.databaseTableSection.querySelectorAll('#wpstg_select_tables_cloning option:checked');
    const regexPattern = this.getRegexPattern();
    options.forEach((option) => {
      const name = option.getAttribute('name', '');
      if (!name.match(regexPattern)) {
        selectedTablesWithoutPrefix.push(option.value);
      }
    });

    return selectedTablesWithoutPrefix.join(this.wpstgObject.settings.directorySeparator);
  }

  getIncludedTables() {
    const includedTables = [];
    const options = this.databaseTableSection.querySelectorAll('#wpstg_select_tables_cloning option:checked');
    const regexPattern = this.getRegexPattern();
    options.forEach((option) => {
      const name = option.getAttribute('name', '');
      if (name.match(regexPattern)) {
        includedTables.push(option.value);
      }
    });

    return includedTables.join(this.wpstgObject.settings.directorySeparator);
  }

  getExcludedTables() {
    const excludedTables = [];
    const options = this.databaseTableSection.querySelectorAll('#wpstg_select_tables_cloning option:not(:checked)');
    const regexPattern = this.getRegexPattern();
    options.forEach((option) => {
      const name = option.getAttribute('name', '');
      if (name.match(regexPattern)) {
        excludedTables.push(option.value);
      }
    });

    return excludedTables.join(this.wpstgObject.settings.directorySeparator);
  }
}
